import { TabContext, TabPanel } from "@mui/lab";
import {
  FormControl,
  InputBase,
  InputLabel,
  OutlinedInput,
  Tab,
  Tabs,
} from "@mui/material";
import Dialog from "components/common/Dialog";
import Box from "components/common/Box";
import Text from "components/common/Text";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import FeedbackSuccessfulTable from "./FeedbackSuccessfulTable";
import FeedbackUnsuccessfulTable from "./FeedbackUnsuccessfulTable";
import DrawerFeedback from "./DrawerFeedback";
import Grid from "components/common/Grid";
import Paper from "components/common/Paper";
import * as XLSX from "xlsx";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import IconButton from "components/common/IconButton";
import { GridSearchIcon } from "@mui/x-data-grid";
import InputAdornment from "components/common/InputAdornment";
import DatePickerModal from "components/common/DatePickerModal";
import EventIcon from "@mui/icons-material/Event";
import { FeedbackApi } from "stores/Feedback/FeedbackApi";
import ChargingStation from "containers/ChargingStation";

const Feedback = ({
  onChange,
  status,
  datePickerOpen,
  handleDatePickerOpen,
  handleDatePickerClose,
  from_date,
  to_date,
  feedback_reply,
  fromat_date_from,
  fromat_date_to,
  onDatePickerSub,
  value,
  handleTabChange,
  toggleDrawer,
  drawerOpen,
  data,
  review,
  date,
  time,
  customerName,
  handleReplyOnChange,
  handleReplySubmit,
  messageReply,
  problemText,
  replyText,
  isLoading,
  totalCount,
  page,
  limit,
  searchhandleChange,
  onPageChange,
  handleReset
}) => {
  const [feedbackExcelData, setfeedbackExcelData] = useState("");
  useEffect(() => {
    const fetchVehicleData = async () => {
      try {
        const limit = totalCount;
        const data = await FeedbackApi.getbulkExcelFeedbackData({
          limit,
          status,
        });
        const expendData = data?.result?.data;

        setfeedbackExcelData(expendData);
      } catch (error) {
        console.error("Error exporting feedback data:", error);
      }
    };

    fetchVehicleData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalCount]);
  const downloadAsExcel = () => {
    let dataToDownload = [];
    if (value === "successful") {
      dataToDownload = feedbackExcelData;
    } else if (value === "unsuccessful") {
      dataToDownload = feedbackExcelData;
    }
    if (dataToDownload.length === 0) {
      return;
    }
    const searchHistorydata = feedbackExcelData.map((d) => ({
      'Customer Name': d?.customer_name,
      'Charging Station': d?.charging_station_name,
      'Name of network':d?.charging_network,
       Review: d?.feedback,
       Rating:d?.rating,
       Date: d?.date,
      'Charging Time': d?.time,
      'Units Charged': d?.units_charged,
       Amount: d?.amount
    }));
    const worksheet = XLSX.utils.json_to_sheet(searchHistorydata);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "navigation Data");
    XLSX.writeFile(workbook, "Feedbackdata.xlsx");
  };
  
  const classes = useStyles();
  return (
    <>
      <Grid container>
        <Grid item xs={12} lg={12}>
          <Paper sx={{ p: 3, mt: 3.5, marginLeft: "5px" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Text
                variant="h5"
                color="#707070"
                sx={{ fontSize: "22px", marginBottom: "40px" }}
              >
                Feedback
              </Text>
              <span
                onClick={() => downloadAsExcel()}
                className={classes.exportfile}
              >
                <FileDownloadIcon className={classes.fileDownload_icon} />
                Export Report
              </span>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{ maxWidth: 200, minWidth: 200,}}>
                <FormControl fullWidth size="small">
                  <InputLabel
                    sx={{ fontSize: "13px"}}
                    id="daterange-label"
                  >
                    Date Range
                  </InputLabel>
                  <OutlinedInput
                    label="Date Range"
                    className={classes.table_date}
                    id="outlined-adornment-amount"
                    value={
                      fromat_date_from && fromat_date_to
                        ? `${fromat_date_from} - ${fromat_date_to}`
                        : ""
                    }
                    onClick={handleDatePickerOpen}
                    endAdornment={
                      <InputAdornment position="end" sx={{cursor:'pointer'}}>
                        <EventIcon />
                      </InputAdornment>
                    }
                    sx={{fontSize:'11px'}}
                  />
                </FormControl>
                <div></div>
              </Box>
              <Dialog
                open={datePickerOpen !== undefined ? datePickerOpen : false}
                onClose={handleDatePickerClose}
                title="Select a date range"
                children={
                  <DatePickerModal
                    onClose={handleDatePickerClose}
                    onDatePickerSub={onDatePickerSub}
                    from_date={from_date}
                    to_date={to_date}
                    handleChange={onChange}
                    handleReset={handleReset}
                  />
                }
              />
              <Box  className={classes.searchBox}>
                <Paper className={classes.searchBox_paper}>
                  <IconButton
                    type="submit"
                    sx={{ p: "5px" }}
                    aria-label="search"
                  >
                    <GridSearchIcon />
                  </IconButton>
                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Search"
                    onChange={(e) =>
                      searchhandleChange("inputsearch", e.target.value)
                    }
                    inputProps={{ "aria-label": "search" }}
                  />
                </Paper>
              </Box>
            </Box>
            <TabContext value={value}>
              <Box
                sx={{ borderBottom: 1, borderColor: "divider", marginTop: 3 }}
              >
                <Tabs
                  value={value}
                  onChange={handleTabChange}
                  aria-label="lab API tabs example"
                >
                  <Tab
                    label="Successful"
                    sx={{ textTransform: "none" }}
                    value="successful"
                  />
                  <Tab
                    label="Unsuccessful"
                    sx={{ textTransform: "none" }}
                    value="unsuccessful"
                  />
                </Tabs>
              </Box>
              <TabPanel value="successful">
                <FeedbackSuccessfulTable
                  data={data.data}
                  onPageChange={onPageChange}
                  totalCount={totalCount}
                  page={page}
                  limit={limit}
                  toggleDrawer={toggleDrawer}
                  isLoading={isLoading}
                />
              </TabPanel>
              <TabPanel value="unsuccessful">
                <FeedbackUnsuccessfulTable
                  data={data.data}
                  toggleDrawer={toggleDrawer}
                  isLoading={isLoading}
                  totalCount={totalCount}
                  page={page}
                  limit={limit}
                  onPageChange={onPageChange}

                />
              </TabPanel>
            </TabContext>
          </Paper>
        </Grid>
      </Grid>
      <DrawerFeedback
        toggleDrawer={toggleDrawer}
        drawerOpen={drawerOpen}
        feedBackreview={review}
        feedbackCustomerName={customerName}
        feedBackdate={date}
        feedbacktime={time}
        handleReplyOnChange={handleReplyOnChange}
        handleReplySubmit={handleReplySubmit}
        messageReply={messageReply}
        problemText={problemText}
        replyText={replyText}
        FeedbackChargingStation={ChargingStation}
        feedback_reply={feedback_reply}
      />
    </>
  );
};
const useStyles = makeStyles((theme) => ({
  exportfile: {
    background: "#19AA69",
    cursor: "pointer",
    height: "25px",
    borderRadius: "30px",
    color: "white",
    display: "flex",
    width: "120px",
    padding: "5px 15px",
  },
  fileDownload_icon: {
    fontSize: "20px",
    marginTop: "3px",
  },

  table_date: {
    "@media (max-width:768px)": {
      width: "218%",
    },
  },
  searchBox: {
    float: "right",
    display: "flex",
    textAlign: "right",
    alignContent: "flex-end",
    borderRadius: "5px !important",
    marginBottom: "20px",
    "@media (max-width:768px)": {
      float: "none",
      marginTop: "-38px",
      marginBottom: "20px",
    },
  },

}));
export default Feedback;
